/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupeIcon16Solid = forwardRef('SearchLoupeIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 .3a6.7 6.7 0 1 0 3.978 12.092l2.317 2.317a1 1 0 0 0 1.414-1.414l-2.317-2.317A6.7 6.7 0 0 0 8 .3ZM3.3 7a4.7 4.7 0 1 1 9.4 0 4.7 4.7 0 0 1-9.4 0Z" })));
});
